import { render, staticRenderFns } from "./copasst-menor-editar.vue?vue&type=template&id=c5966ee2&"
import script from "./copasst-menor-editar.vue?vue&type=script&lang=js&"
export * from "./copasst-menor-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports